exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n._fc_fetch .el-form-item__label {\r\n  float: left;\r\n  display: inline-block;\r\n  text-align: right;\r\n  padding-right: 5px;\n}\n._fc_fetch {\r\n  background-color: #bfdaf7;\r\n  padding: 10px;\n}\r\n", ""]);

// exports
